module.exports = __webpack_public_path__ + "static/tdcw-bc-front-dark-8857c4c1d013bef8c90f7d1516d762e3.png";